import { useMutation } from '@hooks/reactQuery';

import { runCorrelation } from '@api/kpi';

import { ICorrelateDTO } from '@interfaces/kpi/dto/kpiDTO';

import { refetchOptions } from '@constants/common';
import { CORRELATION } from '@constants/queryKeys';

export const useMutateRunCorrelation = () => {
	const {
		data: correlationData,
		mutate: getCorrelation,
		isLoading: isLoadingCorrelation,
	} = useMutation<ICorrelateDTO>({
		mutationKey: [CORRELATION],
		mutationFn: (data: ICorrelateDTO) => runCorrelation(data),
		...refetchOptions,
	});

	return {
		correlationData,
		getCorrelation,
		isLoadingCorrelation,
	};
};
